<template>
  <section >

    <v-parallax src="/static/72240234_2.png" height="200">
    </v-parallax>
    <v-card flat class="toolbar-misCursos" offset-xs1>
    <v-layout row wrap offset-xs1>
      <v-flex xs12 >
        <h3 class="pl-5 mt-4 text-xs-center">Contenido Unidad</h3>
      </v-flex>
      <v-flex xs12 sm3 md3 lg3 xl3 offset-xs2 offset-sm3 offset-lg3 offset-md3 class="text-xs-center">
          <v-btn
            color="red darken-4"
            class="white--text mt-4"
            @click.native="dialogCreatePrueba = true"
          >
            Nueva Prueba
            <v-icon right dark>add</v-icon>
          </v-btn>
      </v-flex>

      <v-flex xs12 sm3 md3 lg3 xl3 class="text-xs-center">
          <v-btn
            color="red darken-4"
            class="white--text mt-4"
            @click.native.stop="dialogCrearLeccion = true"
          >
            Nueva Leccion
            <v-icon right dark>add</v-icon>
          </v-btn>
      </v-flex>
    </v-layout>
    </v-card>
      <v-layout row wrap >
        <v-flex  class=" mt-3" offset-xs1 xl2 lg2 md2 xs12 sm3 v-for="lesson in lessons" :key="lesson.id">
          <button @click="nuevaLeccion(lesson.id)" >
            <v-card  flat class="leccion-card" color="ed darken-4">
              <v-card-title primary-title class="lesson-titulo">
                <v-layout row wrap>
                  <v-flex xs2>
                    <img class="imagen" src="static/ic_book_white_48dp_2x.png">
                  </v-flex>
                   <v-flex xs10  >
                    <p class="p-leccion headline text-xs-center text--white mb-0">Leccion</p>
                  </v-flex>
                  <v-flex xs12  >
                    <p class="subheading centro-card text-xs-center text--white-center mb-0">{{ lesson.lesson_title }}</p>
                  </v-flex>
                </v-layout>
              </v-card-title>
            </v-card>
          </button>
        </v-flex>
      </v-layout>

<!--     <v-dialog v-model="dialogCreatePrueba" max-width="800px">
      <v-card class="float_trans ma-0">
        <v-flex xs12 offset-xs1>
          <v-card-title class="white--text pt-4 pb-0 title">Nueva prueba</v-card-title>
        </v-flex>
        <v-form>
          <v-card-text>
            <v-container grid-list-sm>
              <v-layout row wrap> 
                <v-flex xs12 sm12 md10 offset-xs1>
                  <div id="back-white">
                  <v-text-field
                  :label="prueba.titulo"
                  single-line
                  v-model="prueba.titulo"
                  @input="$v.name.$touch()"
                  @blur="$v.name.$touch()"
                  required
                  ></v-text-field>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md10 offset-xs1>
                  <div id="back-white">
                  <v-text-field
                  name="input-1-3"
                  single-line
                  :label="prueba.descripcion"
                  v-model="prueba.descripcion"
                  @input="$v.name.$touch()"
                  @blur="$v.name.$touch()"
                  ></v-text-field>
                  </div>
                </v-flex>

                <template v-for="(item,index) in prueba.preguntas">
                  <v-container grid-list-sm text-xs-center>
                      <v-flex xs12 sm12 md10 offset-xs1>
                        <v-toolbar flat dark color="grey darken-1">
                        <v-toolbar-title class="white--text">Pregunta {{ index + 1 }}</v-toolbar-title>
                        </v-toolbar>
                      </v-flex>      
                      <v-flex xs12 sm12 md10 offset-xs1>
                        <div id="back-white">
                        <v-text-field
                          name="input-1-3"
                          label="Pregunta"
                          single-line
                          v-model="prueba.preguntas[index].texto"
                        ></v-text-field>
                        </div>
                      </v-flex>
                      <template v-for="(item,index2) in item.alternativas">
                        <v-layout>
                        <v-flex xs1>
                          <span>{{ index2 + 1 }}</span>
                        </v-flex>
                        <v-flex xs12 sm9 md9>
                          <v-flex>
                            <div id="back-white">
                            <v-text-field
                            name="input-1-3"
                            single-line
                            v-model="prueba.preguntas[index].alternativas[index2].textoAlternativa"
                            ></v-text-field>
                            </div>
                          </v-flex>
                        </v-flex>
                        <v-flex xs1 >
                          <div id="back-white">
                          <v-btn @click="console(index,index2)" flat icon color="indigo">
                          <v-icon>star</v-icon>
                          </v-btn>
                          </div>
                        </v-flex>
                        </v-layout>
                      </template>
                          <v-layout>
                        <v-flex xs12 sm5 md5 offset-xs1> 
                          <div id="back-white">
                          <v-select
                            v-model="prueba.preguntas[index].select"
                            label="Seleccione las alternativas correctas"
                            multiple
                            tags
                            :items="item.alternativas"
                            item-text="textoAlternativa"
                          ></v-select>
                          </div>
                        </v-flex>
                        <v-flex xs12 sm5 md5>
                          <div id="back-white">
                            <v-text-field
                              name="input-1-3"
                              single-line
                              label="Puntaje Pregunta"
                              v-model="prueba.preguntas[index].puntaje"
                            ></v-text-field>
                          </div>
                        </v-flex>
                          </v-layout>
                              <v-flex xs12>
                                <v-btn @click="addAlternativa(prueba, index)" outline color="primary">agregar nueva REspuesta</v-btn>
                              </v-flex>
                          </v-container>
                      </template> 
              </v-layout>
            </v-container>
          </v-card-text>
        </v-form>
      </v-card>
    </v-dialog> -->

      <v-dialog v-model="dialogCrearLeccion"  max-width="500px" >
  <v-card>
     <p class="p-toolbar display-1"><strong>NUEVA LECCION</strong></p>

    <v-form  >
      <v-card-text>
        <v-container grid-list-sm>
                <v-layout row wrap>
                <v-flex xs12 >
                  <v-text-field
                    label="Titulo Para la Leccion"
                    v-model="lesson.lesson_title"
                    :counter="50"
                    required
                  ></v-text-field>
                      <v-text-field
                      name="input-3-1"  
                      label="Descripción breve"
                      multi-line
                      v-model="lesson.lesson_about"
                      rows=3
                      ></v-text-field>
                      <v-text-field
                      name="input-7-1"
                      label="Acerca de la Leccion"
                      multi-line
                      v-model="lesson.lesson_text"
                      rows=3
                      ></v-text-field>
                  <v-text-field
                  label="Agrege la URL del Video"
                  v-model="lesson.lesson_video"
                  required
                  ></v-text-field>
                </v-flex>  
  
          </v-layout>
        </v-container>
        <small>*Campos Obligatorios</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn  color="red darken-4" dark round @click.native="dialogCrearLeccion = false" >Cancelar</v-btn>
        <v-btn  color="red darken-4" dark round @click="submitLeccion(lesson)" >Agregar</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</v-dialog>


<!-- dialogo crear prueba -->

<v-dialog v-model="dialogCreatePrueba" fullscreen transition="dialog-bottom-transition" :overlay=false>

      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon @click.native="dialogCreatePrueba = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Crear Prueba</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click.native="dialogCreatePrueba = false" @click="submitTest(prueba)">Enviar</v-btn>
          </v-toolbar-items>
        </v-toolbar>
           <v-container grid-list-xl text-xs-center>
              <v-layout row wrap>
                <v-flex xs8 offset-xs2>
                  <v-card color="white" class="primary--text">
                    <v-card-title primary-title>
                       <v-flex xs12>
                          <v-text-field
                            name="input-1-3"
                            :label="prueba.titulo"
                            single-line
                            v-model="prueba.titulo"
                          ></v-text-field>
                        </v-flex>
                         <v-flex xs12>
                            <v-text-field
                              name="input-1-3"
                              :label="prueba.descripcion"
                              single-line
                              v-model="prueba.descripcion"
                            ></v-text-field>
                          </v-flex>
                    </v-card-title>
                      <template v-for="(item,index) in prueba.preguntas">
                        <v-container grid-list-md text-xs-center>
                          <v-layout row wrap>
                            <v-toolbar flat dark color="primary">
                              <v-toolbar-title class="white--text">Pregunta {{ index + 1 }}</v-toolbar-title>
                            </v-toolbar>
                             <v-flex xs12>
                              <v-text-field
                                name="input-1-3"
                                label="Pregunta"
                                single-line
                                v-model="prueba.preguntas[index].texto"
                              ></v-text-field>
                            </v-flex>
                              <template v-for="(item,index2) in item.alternativas">
                                 <v-flex xs1>
                                  <span>{{ index2 + 1 }}</span>
                                </v-flex>
                                 <v-flex xs9>
                                  <v-text-field
                                    name="input-1-3"
                                    single-line
                                    v-model="prueba.preguntas[index].alternativas[index2].textoAlternativa"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs2 >
                                  <v-btn @click="console(index,index2)" flat icon color="indigo">
                                    <v-icon>star</v-icon>
                                  </v-btn>
                                </v-flex>
                              </template>
                              <v-flex xs12>
                               <v-btn @click="addAlternativa(prueba, index)" outline color="primary">agregar nueva REspuesta</v-btn>
                                </v-flex>
                              <v-flex xs8>
                                <v-select
                                  v-model="prueba.preguntas[index].select"
                                  label="Seleccione las alternativas correctas"
                                  multiple
                                  tags
                                  :items="item.alternativas"
                                  item-text="textoAlternativa"
                                ></v-select>
                              </v-flex>
                              <v-flex xs4>
                                <v-text-field
                                    name="input-1-3"
                                    single-line
                                    label="Puntaje Pregunta"
                                    v-model="prueba.preguntas[index].puntaje"
                                  ></v-text-field>
                              </v-flex>
                            </v-layout>
                          </v-container>
                      </template> 
                      <v-btn @click="addPregunta(prueba, index)" outline color="primary">Agregar Nueva Pregunta</v-btn>

                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
      </v-card>
    </v-dialog>


  </section>
</template>

<script>
import { leccionService } from '@/services/Leccion.service'
import { getLessonsPerUnity } from '@/services/GetLessonsPerUnity.service'
import { testService } from '@/services/Test.service'
export default {
  data () {
    return {
      id_unidad: 0,
      lessons: {},
      lesson: {},
      dialogCrearLeccion: false,
      dialogCreatePrueba: false,
      pregunta: {
        texto: 'Pregunta',
        alternativas: [],
        select: [],
        puntaje: 'Puntaje Pregunta'
      },
      alternativa: {
        textoAlternativa: 'Option1'
      },
      prueba: {
        titulo: 'Titulo de la Prueba',
        descripcion: 'Descripción de la prueba',
        preguntas: []
      }
    }
  },
  methods: {
    loadLecciones (id) {
      let vm = this
      getLessonsPerUnity.getById(vm.id_unidad).then(data => {
        vm.lessons = data.body
      })
      vm.pregunta.alternativas.push(vm.alternativa)
      vm.prueba.preguntas.push(vm.pregunta)
    },
    editar () {
      this.editable = false
    },
    submitLeccion (model) {
      let vm = this
      model.unity_id = vm.id_unidad
      leccionService.save(model).then(data => {
        vm.lessons = data.body
        vm.dialogCrearUnity = false
      }, response => {
      })
    },
    nuevaLeccion (id) {
      this.$router.push({name: 'newLesson', params: {id: id}})
    },
    addAlternativa (model, index) {
      let vm = this
      vm.prueba = model
      var alternativa = {}
      alternativa.textoAlternativa = 'Option1'
      vm.prueba.preguntas[index].alternativas.push(alternativa)
    },
    addPregunta (model) {
      let vm = this
      vm.prueba = model
      var pregunta = {}
      pregunta.texto = 'Pregunta'
      pregunta.alternativas = []
      pregunta.select = []
      vm.prueba.preguntas.push(pregunta)
    },
    console (index, index2) {
    },
    submitTest (model) {
      let vm = this
      model.unity_id = vm.id_unidad
      testService.save(model).then(data => {
        vm.lessons = data.body
      }, response => {
      })
    }
  },
  mounted () {
    let vm = this
    vm.id_unidad = vm.$route.params.id
    vm.loadLecciones(vm.id_unidad)
  }
}
</script>

<style scoped>
.float_trans{
    margin-top: 5%;
    background: rgba(235, 99, 48, 0.6);
    filter: alpha(opacity=30); /*For IE8 and earlier*/
  }

.header-card{
  background-color: #0d47a1;
  color: white
}

.toolbar-misCursos{
  padding: 0.2em;
  margin: 0.5em;


}

.expansion-panel__header {
  padding: 0px !important;
}

.imagen{
  max-width: 50px;
  max-height: 50px;
  height: 50px;
  width: 50px;
  margin-top: 40px

}

.centro-card {
  background-color: #0277BD;
  color: white;
  min-height: 50px;
  margin-top: 40px;
  padding-top: 10px;
}


.leccion-card {
  background-color: #BF360C;
  height: 250px;
  min-height: 250px;
}

.lesson-titulo {
      padding: 0px;
}

.p-leccion{
  color: white;
   margin-top: 45px;



}

.p-toolbar{
  color: white;
  margin-top: 10px;
  align-items: center;
  text-align: center; 
  padding-top: 10px; 
  background-color: #BF360C;
  padding-bottom: 10px 
}

.sin-padding {
  padding: 0px;
}

  #back-white{
    background-color: white;
    margin-bottom:2%;
  }

</style>




// WEBPACK FOOTER //
// src/components/Unidad/ContentUnity.vue